<template>
  <main class="page-content" v-if="page">
    <hero :page="page"></hero>
    <div class="categories container">
      <h2>Categories</h2>
      <ul>
        <li v-for="category in page.resources"><a :href="'#' + category.category | toSlug">{{ category.category }}</a></li>
      </ul>
    </div>
    <section>
      <div class="resources-list container" v-for="category in page.resources" :id="category.category | toSlug">
        <h3>{{ category.category }}</h3>
        <ul>
          <li v-for="item in category.resources"><a :href="item.url" target="_blank" v-html="item.link_text"></a></li>
        </ul>
      </div>
    </section>
  </main>
</template>

<script>
import Hero from '@/components/common/Hero'

export default {
  name: 'resources',
  components: {
    Hero
  },
  data () {
    return {
      loading: true,
      page: null
    }
  },
  mounted () {
    this.fetchPost()
  },
  methods: {
    fetchPost () {
      let vm = this
      // GET /posts => get_single_post() [theme-folder]/api/functions.php
      vm.$axios.get('/posts', {
        params: {
          slug: 'resources'
        }
      })
      .then((response) => {
        vm.page = response.data
        process.nextTick(() => {
          vm.loading = false
          if (vm.$route.hash) vm.scrollToAnchor()
        })
      })
      .catch((err) => {
        vm.loading = false
        console.log(err)
      })
    },
    scrollToAnchor () {
      let id = this.$route.hash.replace('#', '')
      process.nextTick(() => {
        document.getElementById(id).scrollIntoView()
      })
    }
  },
  filters: {
    toSlug (value) {
      let slug = ''
      let titleLower = value.toLowerCase()
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e')
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a')
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o')
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u')
      slug = slug.replace(/đ/gi, 'd')
      slug = slug.replace(/\s*$/g, '')
      slug = slug.replace(/\s+/g, '-')
      return slug
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="sass" scoped>
  @import ../assets/styles/colors
  @import ../assets/styles/mixins

  .page-content
    background: #fff
    padding-bottom: 50px
  .categories
    background: $body-background
    padding: 20px 50px
    margin-bottom: 56px
    h2
      text-transform: uppercase
      font-weight: bold
      text-align: center
      margin: 0 -50px
      display: flex
      align-items: center
      font-size: 22px
      margin-bottom: 10px
      &:before, &:after
        flex: 1
        border-bottom: 6px solid $yellow
        content: ''
        display: block
      &:before
        margin-right: 20px
      &:after
        margin-left: 20px
    ul
      +tablet
        column-count: 6
        li
          font-size: 20px
          font-weight: bold
          line-height: 40px
    a
      color: $textColor
      &:hover
        text-decoration: underline
  .resources-list
    ul
      +smTablet
        column-count: 2
      margin-bottom: 80px
      li
        display: flex
        align-items: flex-start
        margin-top: 9px
        margin-bottom: 9px
        +tablet
          font-size: 22px
        &:before
          content: '•'
          margin-right: 14px
          margin-left: 24px
          font-size: 34px
          position: relative
          top: -3px
          line-height: 22px
          +tablet
            line-height: 33px
    h3
      font-size: 28px
      font-weight: bold
      display: flex
      align-items: center
      margin-bottom: 20px
      &:before
        content: ''
        background-color: $yellow
        width: 38px
        height: 38px
        border-radius: 50%
        display: inline-block
        margin-right: 14px
    a
      color: $textColor
      &:hover
        text-decoration: underline
</style>



// WEBPACK FOOTER //
// Resources.vue?3abcd962